module.exports = __webpack_public_path__ + "static/media/hk.98d52d17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/hk.svg
// module id = 140
// module chunks = 0